import MemriseApi from '../MemriseApi';
import { MinimalMissionsResponse } from './schema';

export default class MissionsApiClass extends MemriseApi {
  constructor() {
    super({ endpointPrefix: '/missions' });
  }

  public async getMinimalMissions(): Promise<MinimalMissionsResponse> {
    return await this.get(`/minimal/`);
  }
}

export const MissionsApi = new MissionsApiClass();
